import React from 'react';
import { Activity, Sparkles } from 'lucide-react';

interface AIProcessingLabProps {
    text: string;
}

const AIProcessingLab: React.FC<AIProcessingLabProps> = ({ text }) => {
    return (
        <div className="fixed inset-0 bg-[#011E26]/95 backdrop-blur-xl z-50 flex items-center justify-center p-6">
            <div className="max-w-md w-full text-center space-y-8 animate-fadeIn">
                <div className="relative">
                    {/* Pulsing Outer Ring */}
                    <div className="absolute inset-0 m-auto w-32 h-32 border-2 border-[#009B8F]/30 rounded-full animate-ping"></div>
                    
                    {/* Rotating Hexagon Frame */}
                    <div className="relative w-32 h-32 mx-auto flex items-center justify-center">
                        <div className="absolute inset-0 border-t-2 border-b-2 border-[#009B8F] rounded-full animate-spin"></div>
                        <div className="absolute inset-2 border-l-2 border-r-2 border-[#009B8F]/50 rounded-full animate-spin reverse"></div>
                        <Activity className="text-[#009B8F]" size={48} />
                    </div>
                </div>

                <div className="space-y-4">
                    <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#009B8F]/10 border border-[#009B8F]/20 text-[#009B8F] text-[10px] font-bold uppercase tracking-[0.2em]">
                        <Sparkles size={12} />
                        Neural Processing Lab
                    </div>
                    
                    <h3 className="text-2xl font-serif text-white">{text}</h3>
                    
                    <div className="flex justify-center gap-1.5">
                        {[0, 1, 2].map((i) => (
                            <div 
                                key={i}
                                className="w-1.5 h-1.5 bg-[#009B8F] rounded-full animate-bounce"
                                style={{ animationDelay: `${i * 0.2}s` }}
                            ></div>
                        ))}
                    </div>

                    <div className="pt-8 grid grid-cols-2 gap-4 text-[10px] font-mono text-[#009B8F]/60 uppercase tracking-widest">
                        <div className="text-right">Querying Global Nodes...</div>
                        <div className="text-left text-white/40">Status: Active</div>
                        <div className="text-right">Analyzing DNA Patterns...</div>
                        <div className="text-left text-white/40">Load: Optimized</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AIProcessingLab;
